import { db } from "../../Environment/firebase";
import { doc, getDoc } from "firebase/firestore";
import { ref, listAll, getDownloadURL, getStorage } from "firebase/storage";
import * as dicomParser from "dicom-parser";

export type dicomFilesRef = {
  file: ArrayBuffer;
  imageId: string;
  name: string;
  instanceNumber: string;
  seriesNumber: string;
  studyId: string;
  seriesId: string;
  instanceId: string;
  protocolName: string;
  share: Boolean;
};

export type basicDicomFilesRef = {
  file: ArrayBuffer;
  imageId: string;
  name: string;
  instanceNumber: string;
  seriesNumber: string;
  studyUId: string;
};

export async function selectStudy(
  firestoreId: string,
  calTotal: (input_num: number) => void,
  calCount: () => void
): Promise<dicomFilesRef[]> {
  let DicomFiles: dicomFilesRef[] = [];
  const docRef = doc(db, "dwh", firestoreId);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    //const caseShare: string = docSnap.data()?.share || '';
    let studyUId = "";
    if (docSnap.data()) {
      studyUId = docSnap.data().studyUId;
    }
    const storage = getStorage();
    // Create a reference under which you want to list
    const listRef = ref(storage, `Kasumi/${studyUId}`);

    DicomFiles = await listAll(listRef).then(async (res) => {
      const DicomStudySeriesFiles = await Promise.all(
        res.prefixes.map(async (folderRef) => {
          const subDocRef = doc(
            db,
            "dwh",
            firestoreId,
            "dicomData",
            folderRef.name
          );
          const subDocSnap = await getDoc(subDocRef);
          let share = false;
          let protocolName = "";
          const subDocSnapData = subDocSnap.data();
          if (subDocSnapData !== undefined) {
            share = subDocSnapData.share;
            protocolName = subDocSnapData.protocol;
          }

          const DicomStudyFiles: dicomFilesRef[] = await listAll(
            folderRef
          ).then(async (res) => {
            calTotal(res.items.length); //setAllCount((pa_count)=>pa_count+res.items.length)
            const DicomSeriesFiles: dicomFilesRef[] = await Promise.all(
              res.items.map(async (itemRef) => {
                // All the items under listRef.
                const dicomFiledict: {
                  file: ArrayBuffer;
                  imageId: string;
                  instanceNumber: string;
                  seriesNumber: string;
                  name: string;
                } = await getDownloadURL(itemRef).then(async (url) => {
                  const fileBuffer = await getDicomBufferArray(url);
                  var byteArray = new Uint8Array(fileBuffer);
                  const dicomDataSet = dicomParser.parseDicom(byteArray);
                  const instanceNumber = dicomDataSet.string("x00200013") || "";
                  const seriesNumber = dicomDataSet.string("x00200011") || "";
                  const dicomBlob = new Blob([byteArray], {
                    type: "application/dicom",
                  });
                  const imageId = URL.createObjectURL(dicomBlob);

                  return {
                    file: fileBuffer,
                    imageId: "dicomweb:" + imageId,
                    instanceNumber: instanceNumber,
                    seriesNumber: seriesNumber,
                    name: seriesNumber + instanceNumber + ".dcm",
                  };
                });
                calCount(); //setCount((count) => count+1)
                return {
                  file: dicomFiledict.file,
                  imageId: dicomFiledict.imageId,
                  instanceNumber: dicomFiledict.instanceNumber,
                  seriesNumber: dicomFiledict.seriesNumber,
                  name: dicomFiledict.name,
                  studyId: studyUId,
                  seriesId: folderRef.name,
                  instanceId: itemRef.name,
                  protocolName: protocolName,
                  share: share,
                };
              })
            );
            return DicomSeriesFiles;
          });
          return DicomStudyFiles;
        })
      );
      const DicomFilesBase = DicomStudySeriesFiles.flat();
      const DicomFiles = DicomFilesBase.filter(
        (item) => item.name !== "None.txt"
      );
      return DicomFiles;
    });

    return DicomFiles;
    //openViewer(topFolder);
  } else {
    return DicomFiles;
  }
}

export async function extractBasicDicom(
  path: string,
  series: number,
  start: number,
  end: number,
  studyUId: string,
  calTotal: (input_num: number) => void,
  calCount: () => void
): Promise<basicDicomFilesRef[]> {
  calTotal(end - start + 1);
  const storage = getStorage();
  const pathname = path;
  var images = [];
  for (let i = start - 1; i < end; i++) {
    let fileName = series + "_" + String(i + 1) + ".dcm";
    images.push(pathname + "/" + fileName);
  }
  const dicomFiles = await Promise.all(
    images.map(async (image) => {
      const dicomFiledict: {
        file: ArrayBuffer;
        imageId: string;
        instanceNumber: string;
        seriesNumber: string;
        name: string;
        studyUId: string;
      } = await getDownloadURL(ref(storage, image)).then(async (url) => {
        const fileBuffer = await getDicomBufferArray(url);
        var byteArray = new Uint8Array(fileBuffer);
        const dicomDataSet = dicomParser.parseDicom(byteArray);
        const instanceNumber = dicomDataSet.string("x00200013") || "";
        const seriesNumber = dicomDataSet.string("x00200011") || "";
        const dicomBlob = new Blob([byteArray], {
          type: "application/dicom",
        });

        const imageId = URL.createObjectURL(dicomBlob);
        return {
          file: fileBuffer,
          imageId: "dicomweb:" + imageId,
          instanceNumber: instanceNumber,
          seriesNumber: seriesNumber,
          name: seriesNumber + instanceNumber + ".dcm",
          studyUId: studyUId,
        };
      });
      calCount();
      return {
        file: dicomFiledict.file,
        imageId: dicomFiledict.imageId,
        instanceNumber: dicomFiledict.instanceNumber,
        seriesNumber: dicomFiledict.seriesNumber,
        name: dicomFiledict.name,
        studyUId: dicomFiledict.studyUId,
      };
    })
  );
  return dicomFiles;
}

export async function extractDicomDataAsSeries(
  firestoreId: string,
  studyUId: string,
  seriesUId: string,
  calTotal: (input_num: number) => void,
  calCount: () => void
): Promise<dicomFilesRef[]> {
  const storage = getStorage();
  const fileListRef = ref(storage, `Kasumi/${studyUId}/${seriesUId}`);

  const subDocRef = doc(db, "dwh", firestoreId, "dicomData", seriesUId);
  const subDocSnap = await getDoc(subDocRef);
  let share = false;
  let protocolName = "";
  const subDocSnapData = subDocSnap.data();
  if (subDocSnapData !== undefined) {
    share = subDocSnapData.share;
    protocolName = subDocSnapData.protocol;
  }

  const DicomSeriesFiles: dicomFilesRef[] = await listAll(fileListRef).then(
    async (res) => {
      calTotal(res.items.length); //setAllCount((pa_count)=>pa_count+res.items.length)
      const DicomSeriesFileItems: dicomFilesRef[] = await Promise.all(
        res.items.map(async (itemRef) => {
          // All the items under listRef.
          const dicomFiledict: {
            file: ArrayBuffer;
            imageId: string;
            instanceNumber: string;
            seriesNumber: string;
            name: string;
          } = await getDownloadURL(itemRef).then(async (url) => {
            const fileBuffer = await getDicomBufferArray(url);
            var byteArray = new Uint8Array(fileBuffer);
            const dicomDataSet = dicomParser.parseDicom(byteArray);
            const instanceNumber = dicomDataSet.string("x00200013") || "";
            const seriesNumber = dicomDataSet.string("x00200011") || "";
            const dicomBlob = new Blob([byteArray], {
              type: "application/dicom",
            });
            const imageId = URL.createObjectURL(dicomBlob);

            return {
              file: fileBuffer,
              imageId: "dicomweb:" + imageId,
              instanceNumber: instanceNumber,
              seriesNumber: seriesNumber,
              name: seriesNumber + instanceNumber + ".dcm",
            };
          });
          calCount(); //setCount((count) => count+1)
          return {
            file: dicomFiledict.file,
            imageId: dicomFiledict.imageId,
            instanceNumber: dicomFiledict.instanceNumber,
            seriesNumber: dicomFiledict.seriesNumber,
            name: dicomFiledict.name,
            studyId: studyUId,
            seriesId: fileListRef.name,
            instanceId: itemRef.name,
            protocolName: protocolName,
            share: share,
          };
        })
      );
      return DicomSeriesFileItems;
    }
  );

  return DicomSeriesFiles;
}

export function getDicomBufferArray(URL: string): Promise<ArrayBuffer> {
  return new Promise((resolve, reject) => {
    let req = new XMLHttpRequest();
    req.responseType = "arraybuffer";
    req.open("GET", URL, true);
    req.onload = (event) => {
      if (req.status === 200) {
        const fileBuffer: ArrayBuffer = req.response;
        resolve(fileBuffer);
      }
    };
    req.send();
  });
}
